var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agent-action-box"},[_c('el-dialog',{staticClass:"el-dialogs",attrs:{"title":`渠道号${_vm.channel} ${_vm.title}`,"visible":_vm.dialogVisible,"width":"1650px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{ref:"regChart",staticClass:"line",staticStyle:{"width":"1600px","height":"400px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }